import { post } from "../../services";
import {
    ACTIVATE_ROOMTYPE,
    ADD_NEW_COUPON,
    ADD_NEW_FACILITY,
    ADD_NEW_HIGHLIGHT,
    ADD_NEW_RATE,
    ADD_NEW_RESTAURANT_INVOICE,
    ADD_NEW_ROOM_TYPE,
    CHANGE_HOTEL_PASSWORD,
    CHECK_ROOM_AVAILABILITY,
    GET_LINKED_RESTAURANT_INVOICES,
    LINK_RESTAURANT_INVOICE_TO_HOTEL_INVOICE,
    LIST_ALL_COUPONS,
    LIST_ALL_EXTRA_INVOICES,
    LIST_ALL_FACILITIES,
    LIST_ALL_HIGHLIGHTS,
    LIST_ALL_HOTEL_INVOICES,
    LIST_ALL_RATES,
    LIST_ALL_RESTAURANT_INVOICES,
    LIST_ALL_ROOM_TYPES,
    LIST_EXTRA_INVOICES_DETAILS,
    LIST_HOTEL_INVOICES_DETAILS,
    LIST_HOTEL_NOTIFICATIONS,
    LIST_RESTAURANT_INVOICE_DETAILS,
    LIST_ROOMTYPE_DETAILS,
    PREVIEW_HOTEL_INVOICE,
    SEARCH_HOTEL_BOOKINGS,
    SEARCH_HOTEL_INVOICES,
    SETTLE_HOTEL_INVOICE,
    UNLINK_RESTAURANT_INVOICE,
    UPDATE_BOOKING_ENGINE_VISIBILITY,
    UPDATE_COUPON,
    UPDATE_EXTRA_INVOICES_DETAILS,
    UPDATE_HOTEL_INVOICES_DETAILS,
    UPDATE_RESTAURANT_INVOICE_STATUS,
    UPDATE_ROOMTYPE,
    UPLOAD_FILE,
} from "../../graphql";
import {
    RESET__EXTRA_INVOICES_DETAILS,
    RESET__HOTEL_INVOICES_DETAILS,
    RESET_ALL_COUPONS_DATA,
    RESET_ALL_EXTRA_INVOICES,
    RESET_ALL_FACILITIES_DATA,
    RESET_ALL_HIGHLIGHTS_DATA,
    RESET_ALL_HOTEL_INVOICES,
    RESET_ALL_RATES,
    RESET_ALL_RESTAURANT_INVOICES,
    RESET_ALL_ROOM_TYPES_LIST,
    RESET_AVALABLE_ROOMS,
    RESET_RESTAURANT_INVOICE_DETAILS,
    RESET_ROOMTYPE_DETAILS,
    SAVE_ALL_COUPONS,
    SAVE_ALL_EXTRA_INVOICES,
    SAVE_ALL_FACILITIES,
    SAVE_ALL_HIGHLIGHTS,
    SAVE_ALL_HOTEL_INVOICES,
    SAVE_ALL_RATES,
    SAVE_ALL_RESTAURANT_INVOICES,
    SAVE_ALL_ROOM_TYPES_LIST,
    SAVE_AVALABLE_ROOMS,
    SAVE_EXTRA_INVOICES_DETAILS,
    SAVE_HOTEL_INVOICES_DETAILS,
    SAVE_HOTEL_NOTIFICATIONS,
    SAVE_RESTAURANT_INVOICE_DETAILS,
    SAVE_ROOMTYPE_DETAILS,
    TOGGLE_LOADING,
} from "../types";
import { toast } from "react-toastify";

export const addNewHighlight = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_HIGHLIGHT,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllHighlightsData());
            dispatch(listAllHighlights());
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllHighlights = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        const {
            highlights: { pageSize, pageNumber, list },
        } = getState().admin;

        let apiResponse = await post("", {
            query: LIST_ALL_HIGHLIGHTS,
            variables: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_highlights: { data, hasMore },
            } = apiResponse.data.data;

            let updatedList = [...list, ...data];

            dispatch({
                type: SAVE_ALL_HIGHLIGHTS,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllHighlightsData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_HIGHLIGHTS_DATA });
    };
};

export const addNewFacility = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_FACILITY,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllFacilitiesData());
            dispatch(listAllFacilities());
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllFacilities = (requestData) => {
    return async (dispatch, getState) => {
      dispatch({ type: TOGGLE_LOADING, payload: true });
  
      const {
        facilities: { pageSize, pageNumber, list },
      } = getState().admin;
  
      let apiResponse = await post("", {
        query: LIST_ALL_FACILITIES,
        variables: {
          pageSize: pageSize,
          pageNumber: pageNumber,
          ...requestData,
        },
      });
  
      if (apiResponse.data.customStatus) {
        let {
                list_all_facilities: { data, hasMore },
        } = apiResponse.data.data;
  
        let updatedList = [...list, ...data];
  
        dispatch({
          type: SAVE_ALL_FACILITIES,
          payload: {
            list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
          },
        });
      }
      dispatch({ type: TOGGLE_LOADING, payload: false });
    };
  };
  
export const resetAllFacilitiesData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_FACILITIES_DATA });
    };
};

export const checkRoomAvailability = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const {
            availableRooms: { pageSize, pageNumber, list },
        } = getState().admin;

        let apiResponse = await post("", {
            query: CHECK_ROOM_AVAILABILITY,
            variables: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                check_room_availability: { data, hasMore },
            } = apiResponse.data.data;
            let updatedList = [...list, ...data];
            dispatch({
                type: SAVE_AVALABLE_ROOMS,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: 1,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAvalableRoomsData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_AVALABLE_ROOMS });
    };
};

export const addNewRate = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_RATE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRatesData());
            dispatch(listAllRates());
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllRates = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const {
            rates: { pageSize, pageNumber, list },
        } = getState().admin;

        let apiResponse = await post("", {
            query: LIST_ALL_RATES,
            variables: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_rates: { data, hasMore },
            } = apiResponse.data.data;
            let updatedList = [...list, ...data];

            dispatch({
                type: SAVE_ALL_RATES,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: 1,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllRatesData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_RATES });
    };
};

export const addNewNewRoomType = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_ROOM_TYPE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomTypesList());
            dispatch(listAllRoomTypes());
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const activateRoomtype = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ACTIVATE_ROOMTYPE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomTypesList());
            dispatch(listAllRoomTypes());
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllRoomTypes = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const {
            roomTypes: { pageSize, pageNumber },
        } = getState().admin;

        let apiResponse = await post("", {
            query: LIST_ALL_ROOM_TYPES,
            variables: {
                ...requestData,
                pageSize: requestData?.isForDropdown ? 200 : requestData?.pageSize || pageSize,
                pageNumber: requestData?.pageNumber || pageNumber,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_roomtypes: { data, hasMore, count },
            } = apiResponse.data.data;
            // let updatedList = [...list, ...data];
            // console.log(apiResponse);
            dispatch({
                type: SAVE_ALL_ROOM_TYPES_LIST,
                payload: {
                    list: data,
                    showViewMore: hasMore,
                    pageSize: requestData?.pageSize || pageSize,
                    pageNumber: requestData?.pageNumber || pageNumber,
                    count: count,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllRoomTypesList = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_ROOM_TYPES_LIST });
    };
};

export const updateRoomtype = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_ROOMTYPE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetRoomTypeDetails());
            dispatch(listRoomTypeDetails({id: requestData?.id}));
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const updateBookingEngineVisibility = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_BOOKING_ENGINE_VISIBILITY,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetRoomTypeDetails());
            dispatch(listRoomTypeDetails({id: requestData?.id}));
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listRoomTypeDetails = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_ROOMTYPE_DETAILS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                list_roomtype_details: { data },
            } = apiResponse.data.data;
            dispatch({
                type: SAVE_ROOMTYPE_DETAILS,
                payload: data,
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetRoomTypeDetails = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ROOMTYPE_DETAILS });
    };
};

export const listHotelNotifications = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_HOTEL_NOTIFICATIONS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                get_hotel_notifications: { data },
            } = apiResponse.data.data;
            dispatch({
                type: SAVE_HOTEL_NOTIFICATIONS,
                payload: data,
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetHotelNotifications = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ROOMTYPE_DETAILS });
    };
};

export const uploadFile = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPLOAD_FILE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                upload_file: { url },
            } = apiResponse.data.data;

            dispatch({ type: TOGGLE_LOADING, payload: false });
            return url;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const changeHotelPassword = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: CHANGE_HOTEL_PASSWORD,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            toast.success("Password updated");
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const addNewCoupon = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_COUPON,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
             toast.success("Coupon added successfully");
            dispatch(resetAllCouponsData());
            dispatch(listAllCoupons());
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllCoupons = (requestData = {}) => {
    return async (dispatch, getState) => {
      dispatch({ type: TOGGLE_LOADING, payload: true });
  
      const {
        admin: {
          coupons: { pageSize = 10, pageNumber = 1, list = [] },
        },
      } = getState();
  
      try {
        const apiResponse = await post("", {
          query: LIST_ALL_COUPONS,
          variables: {
            page_size: pageSize,
            page_number: pageNumber, 
            ...requestData,
          },
        });
  
        if (apiResponse.data.customStatus) {
          const { data, hasMore, totalCount } = apiResponse.data.data.list_all_coupons;
  
          const newData = data.filter(
            (item) => !list.some((existing) => existing._id === item._id)
          );
  
          dispatch({
            type: SAVE_ALL_COUPONS,
            payload: {
              list: [...list, ...newData],
              showViewMore: hasMore,
              pageNumber: pageNumber + 1,
              totalCount,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching coupons:", error);
      } finally {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    };
  };

 export const updateCoupon = (couponId, checkOutDate) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_COUPON,
            variables: { coupon_id: couponId, check_out_date: checkOutDate },
        });

        if (apiResponse.data.customStatus) {
            toast.success("Coupon updated successfully");
            const {
                admin: {
                    coupons: { pageSize = 10, pageNumber = 1, list = [] },
                },
            } = getState();

            const updatedList = list.map(coupon =>
                coupon._id === couponId ? { ...coupon, check_out_date: checkOutDate } : coupon
            );

            dispatch({
                type: SAVE_ALL_COUPONS,
                payload: {
                    pageSize,
                    pageNumber,
                    list: updatedList,
                },
            });

        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllCouponsData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_COUPONS_DATA });
    };
};

export const listAllHotelInoices = (requestData = {}) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        // When we filter, we always start from page 1 unless a different page is specified
        const page_number = requestData.page_number || 1;

        try {
            const apiResponse = await post("", {
                query: LIST_ALL_HOTEL_INVOICES,
                variables: {
                    // Always send the page size and number
                    page_size: 20, // Or get from state if you allow changing it
                    page_number: page_number,
                    // Send the rest of the filter data (booking_id, room_number, etc.)
                    ...requestData,
                },
            });

            if (apiResponse.data.customStatus) {
                const { data, hasMore, totalCount } = apiResponse.data.data.list_all_hotel_invoices;
                
                dispatch({
                    type: SAVE_ALL_HOTEL_INVOICES,
                    payload: {
                        // ✅ This REPLACES the list with fresh data, which is correct for pagination
                        list: data, 
                        showViewMore: hasMore,
                        pageNumber: page_number, // Use the current page number
                        totalCount,
                    },
                });
            }
        } catch (error) {
            console.error("Error fetching hotel invoices:", error);
        } finally {
            dispatch({ type: TOGGLE_LOADING, payload: false });
        }
    };
};

export const searchHotelInvoices = (requestData = {}) => {
  return async (dispatch) => {
    // dispatch({ type: TOGGLE_LOADING, payload: true });
    try {
      const apiResponse = await post("", {
        query: SEARCH_HOTEL_INVOICES,
        variables: {
          booking_id: requestData.booking_id || null,
          room_number: requestData.room_number || null,
          checkin_date: requestData.checkin_date || null,
          checkout_date: requestData.checkout_date || null,
        },
      });

      if (apiResponse.data.customStatus) {
        const { data } = apiResponse.data.data.search_hotel_invoices;
        // ✅ Just return the result — don’t persist to Redux
        return data || [];
      } else {
        console.error("GraphQL error:", apiResponse.data.errors || apiResponse.data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching hotel invoices:", error);
      return [];
    } finally {
    //   dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetAllHotelInvoices = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_HOTEL_INVOICES });
    };
};

export const listHotelInvoicesDetails = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await post("", {
      query: LIST_HOTEL_INVOICES_DETAILS,
      variables: requestData,
    });

    if (apiResponse.data.customStatus) {
      let {
        list_hotel_invoices_details: { data },
      } = apiResponse.data.data;
      
      dispatch({
        type: SAVE_HOTEL_INVOICES_DETAILS,
        payload: data,
      });
    }

    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetHotelInvoicesDetails= () => {
    return async (dispatch) => {
        dispatch({ type: RESET__HOTEL_INVOICES_DETAILS });
    };
};

export const updateHotelInvoicesDetails = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_HOTEL_INVOICES_DETAILS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetHotelInvoicesDetails());
            dispatch(listHotelInvoicesDetails({id: requestData?._id}));
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllExtraInvoices = (requestData = {}) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        // When we filter, we always start from page 1 unless a different page is specified
        const page_number = requestData.page_number || 1;

        try {
            const apiResponse = await post("", {
                query: LIST_ALL_EXTRA_INVOICES,
                variables: {
                    // Always send the page size and number
                    page_size: 20, // Or get from state if you allow changing it
                    page_number: page_number,
                    // Send the rest of the filter data (booking_id, room_number, etc.)
                    ...requestData,
                },
            });

            if (apiResponse.data.customStatus) {
                const { data, hasMore, totalCount } = apiResponse.data.data.list_all_extra_invoices;
                
                dispatch({
                    type: SAVE_ALL_EXTRA_INVOICES,
                    payload: {
                        // ✅ This REPLACES the list with fresh data, which is correct for pagination
                        list: data, 
                        showViewMore: hasMore,
                        pageNumber: page_number, // Use the current page number
                        totalCount,
                    },
                });
            }
        } catch (error) {
            console.error("Error fetching hotel invoices:", error);
        } finally {
            dispatch({ type: TOGGLE_LOADING, payload: false });
        }
    };
};

export const resetAllExtraInvoices = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_EXTRA_INVOICES });
    };
};

export const listExtraInvoicesDetails = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_EXTRA_INVOICES_DETAILS,
            variables: requestData,
        });
        if (apiResponse.data.customStatus) {
            let {
                list_extra_invoices_details: { data },
            } = apiResponse.data.data;
            dispatch({
                type: SAVE_EXTRA_INVOICES_DETAILS,
                payload: data,
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetExtraInvoicesDetails= () => {
    return async (dispatch) => {
        dispatch({ type: RESET__EXTRA_INVOICES_DETAILS });
    };
};

export const updateExtraInvoicesDetails = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        let apiResponse = await post("", {
            query: UPDATE_EXTRA_INVOICES_DETAILS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetExtraInvoicesDetails());
            dispatch(listExtraInvoicesDetails({id: requestData?._id}));
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllRestaurantInvoices = (requestData = {}) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    // Normalize page number
    const page_number = Math.max(1, requestData.page_number || 1);
    const page_size = Math.min(Math.max(1, requestData.page_size || 20), 100);

    try {
      const apiResponse = await post("", {
        query: LIST_ALL_RESTAURANT_INVOICES,
        variables: {
          page_size,
          page_number,
          // Spread only valid filter fields
          ...(requestData.customer_name && { customer_name: requestData.customer_name.trim() }),
          ...(requestData.pmt_status && { pmt_status: requestData.pmt_status }),
          ...(requestData.inv_no && { inv_no: requestData.inv_no.trim() }),
          ...(requestData.inv_date_from !== undefined && { inv_date_from: Number(requestData.inv_date_from) }),
          ...(requestData.inv_date_to !== undefined && { inv_date_to: Number(requestData.inv_date_to) }),
        },
      });

      if (apiResponse.data?.data?.list_all_restaurant_invoices) {
        const { data, hasMore, totalCount } =
          apiResponse.data.data.list_all_restaurant_invoices;

        dispatch({
          type: SAVE_ALL_RESTAURANT_INVOICES,
          payload: {
            list: data,
            showViewMore: hasMore,
            pageNumber: page_number,
            totalCount,
          },
        });
      } else {
        console.warn("Unexpected API response structure", apiResponse);
      }
    } catch (error) {
      console.error("Error fetching restaurant invoices:", error);
      // Optional: dispatch error action
      // dispatch({ type: FETCH_INVOICES_ERROR, payload: error.message });
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetAllRestaurantInvoices = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ALL_RESTAURANT_INVOICES });
  };
};

export const listRestaurantInvoiceDetails = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const apiResponse = await post("", {
        query: LIST_RESTAURANT_INVOICE_DETAILS,
        variables: requestData,
      });
      if (apiResponse.data.customStatus) {
        const {
          list_restaurant_invoice_details: { data },
        } = apiResponse.data.data;

        dispatch({
          type: SAVE_RESTAURANT_INVOICE_DETAILS,
          payload: data,
        });
      }
    } catch (error) {
      console.error("Error fetching restaurant invoice details:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetRestaurantInvoiceDetails = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_RESTAURANT_INVOICE_DETAILS });
  };
};

export const addNewRestaurantInvoice = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });
    try {
      const apiResponse = await post("", {
        query: ADD_NEW_RESTAURANT_INVOICE,
        variables: requestData,
      });

           const invoice = apiResponse?.data?.data?.add_new_restaurant_invoice;
           if (invoice?._id) {
             toast.success("Invoice created successfully!");
            return invoice._id;
           } else {
             console.error("Failed to create invoice:", apiResponse.data);
             toast.error("Failed to create invoice. Check console for details.");
           }
    } catch (error) {
      console.error("Error adding restaurant invoice:", error);
      toast.error("Failed to add restaurant invoice ❌");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const linkRestaurantInvoiceToHotelInvoice = (requestData) => {
  return async (dispatch) => {
    try {
      const apiResponse = await post("", {
        query: LINK_RESTAURANT_INVOICE_TO_HOTEL_INVOICE,
        variables: {
          restaurantInvoiceId: requestData.restaurantInvoiceId || null,
          bookingId: requestData.bookingId || null,
        },
      });

      const gqlResponse =
        apiResponse.data?.data?.link_restaurant_invoice_to_hotel_invoice;
      const gqlErrors = apiResponse.data?.errors;

      if (apiResponse.data?.customStatus && gqlResponse) {
        const { message } = gqlResponse;
        return {
          success: true,
          message: message || "Restaurant invoice linked successfully.",
        };
      } else {
        console.error(
          "GraphQL error:",
          gqlErrors || apiResponse.data?.message || "Unknown error"
        );
        return {
          success: false,
          message:
            apiResponse.data?.message ||
            gqlErrors?.[0]?.message ||
            "Failed to link restaurant invoice.",
        };
      }
    } catch (error) {
      console.error("Error linking restaurant invoice to hotel invoice:", error);
      return {
        success: false,
        message: "An unexpected error occurred while linking the invoice.",
      };
    }
  };
};

export const unlinkRestaurantInvoice = (requestData) => {
  return async (dispatch) => {
    try {
      const apiResponse = await post("", {
        query: UNLINK_RESTAURANT_INVOICE,
        variables: {
          restaurantInvoiceId: requestData.restaurantInvoiceId || null,
        },
      });

      const gqlResponse =
        apiResponse.data?.data?.unlink_restaurant_invoice;
      const gqlErrors = apiResponse.data?.errors;

      if (apiResponse.data?.customStatus && gqlResponse) {
        const { message, success } = gqlResponse;
        return {
          success: success ?? true,
          message: message || "Restaurant invoice unlinked successfully.",
        };
      } else {
        console.error(
          "GraphQL error:",
          gqlErrors || apiResponse.data?.message || "Unknown error"
        );
        return {
          success: false,
          message:
            apiResponse.data?.message ||
            gqlErrors?.[0]?.message ||
            "Failed to unlink restaurant invoice.",
        };
      }
    } catch (error) {
      console.error("Error unlinking restaurant invoice:", error);
      return {
        success: false,
        message: "An unexpected error occurred while unlinking the invoice.",
      };
    }
  };
};

export const updateRestaurantInvoiceStatus = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const apiResponse = await post("", {
        query: UPDATE_RESTAURANT_INVOICE_STATUS,
        variables: requestData,
      });

      const updated =
        apiResponse?.data?.data?.update_restaurant_invoice_status?.data;

      if (apiResponse?.data?.customStatus && updated) {
        return updated;
      }
    } catch (error) {
      console.error("Error updating restaurant invoice status:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const searchHotelBookings = (requestData = {}) => {
  return async (dispatch) => {
    try {
      const apiResponse = await post("", {
        query: SEARCH_HOTEL_BOOKINGS,
        variables: {
          booking_id: requestData.booking_id || null,
          room_number: requestData.room_number || null,
          checkin_date: requestData.checkin_date || null,
          checkout_date: requestData.checkout_date || null,
        },
      });

      if (apiResponse.data.customStatus) {
        // Note: The key in the response will be 'search_hotel_bookings'
        const { data } = apiResponse.data.data.search_hotel_bookings;
        return data || [];
      } else {
        console.error("GraphQL error:", apiResponse.data.errors || apiResponse.data.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching hotel bookings:", error);
      return [];
    }
  };
};

export const previewHotelInvoice = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await post("", {
      query: PREVIEW_HOTEL_INVOICE,
      variables: requestData,
    });

    dispatch({ type: TOGGLE_LOADING, payload: false });

    if (apiResponse.data.customStatus) {
      let {
        preview_hotel_invoice: { data },
      } = apiResponse.data.data;
      
      // Return the data directly to the component
      return data.hotel_invoice;
    }
    
    return null;
  };
};

export const fetchLinkedRestaurantInvoices = (booking_id) => {
  return async (dispatch) => {
    if (!booking_id) return [];

    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const apiResponse = await post("", {
        query: GET_LINKED_RESTAURANT_INVOICES,
        variables: {
          booking_id: booking_id
        },
      });

      if (apiResponse.data?.data?.get_linked_restaurant_invoices) {
        const { data } = apiResponse.data.data.get_linked_restaurant_invoices;
        
        return data || [];
      } else {
        console.warn("Unexpected response format:", apiResponse);
        return [];
      }
    } catch (error) {
      console.error("Error fetching linked restaurant invoices:", error);
      return [];
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const settleHotelInvoice = (settlementData) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const apiResponse = await post("", {
        query: SETTLE_HOTEL_INVOICE,
        variables: settlementData,
      });

      if (apiResponse.data.customStatus) {
        const { settle_hotel_invoice } = apiResponse.data.data;

        if (settle_hotel_invoice.success) {
          toast.success(settle_hotel_invoice.message);

          dispatch(listHotelInvoicesDetails({ id: settlementData.invoice_id }));
        } else {
          throw new Error(settle_hotel_invoice.message || "Settlement failed");
        }
      } else {
        throw new Error("Settlement failed");
      }
    } catch (error) {
      toast.error(error.message || "Settlement failed");
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};
